<template>
  <div>
    <Header />
    <MenuCategories />
  </div>
</template>

<script>
import Header from './Header.vue';
import MenuCategories from './MenuCategories';

export default {
  name: 'Home',
  components: {
    Header,
    MenuCategories
  }
}
</script>
